/** @typedef {import('../types/entity/IndexData').IndexData} IndexData */

/**
 * @param {number} metricsStartIdx
 * @param {number} timestamp
 * @returns {IndexData}
 */
export const createIndexData = (metricsStartIdx, timestamp = null) => ({
    metricsStartIdx,
    timestamp
});

/**
 * @param {IndexData} a
 * @param {IndexData} b
 */
export const compareIndexData = (a, b) => {
    if (a === null || b === null) return a === b;

    const areEqual = a.metricsStartIdx === b.metricsStartIdx && a.timestamp === b.timestamp;

    return areEqual;
};
